import * as React from 'react';
const Circle = () => {
    return React.createElement("div", { className: "loader w-4 h-4" });
};
export default Circle;
